import { render } from "./login.vue?vue&type=template&id=325846d0&class=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=325846d0&lang=css"
script.render = render

export default script